import { useAuth } from "react-oidc-context";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { SaveCurrentPath } from "../Core";

export const SignIn = () => {
    const { user, signinRedirect } = useAuth();
    const history = useHistory();

    React.useEffect(() => {
        if (!user) {
            SaveCurrentPath(history);
            signinRedirect();
        }
    }, []);

    return null;
}
